$(document).on('click', '.footer-block__heading', function(e){
  if($(window).width() < 768) {
    var is_active = true;
    if($(this).parent().attr('class').indexOf('is-active') > -1) is_active = false;
    if(!$(this).parent().hasClass('is-active')) {
      $('.is-active .footer-block__details-content').slideUp();
    }
    $('.footer-block--menu').removeClass('is-active');
    if(is_active) $(this).parent().addClass('is-active');
    $(this).parent().find('.footer-block__details-content').slideToggle();  
  }
});